import { gql, useQuery } from '@apollo/client';
import { Domain } from '../../../models/types';

interface DomainListData {
  account: {
    domains: Domain[];
  };
}

interface DomainListVars {
  clientId: string;
}

const DOMAIN_LIST = gql`
  query getDomainList($clientId: String!, $piezoArtifacts: JSON) {
    account(clientId: $clientId, piezoArtifacts: $piezoArtifacts) {
      domains {
        domainIdentifier
        name
        created
        deleted
        processing
        carbonDomain
      }
    }
  }
`;

export const useDomainListQuery = (vars: DomainListVars) => {
  // piezoLink auto-derives the getDomains artifact from the account.domains selection
  // (signing/fieldRegistry, keyed by client_id) and injects the $piezoArtifacts map.
  return useQuery<DomainListData, DomainListVars>(DOMAIN_LIST, {
    variables: { ...vars },
  });
};
